import "./App.css";
import React, { useContext, useState, useEffect, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { userEventEmitter } from './eventEmitter';
import { MainPage } from "./pages/main-page/main-page";
import { Login } from "./pages/login/login";
import { Register } from "./pages/register/register";
import { ConfirmMail } from "./pages/confirm-mail/confirm-mail";
import { InformationPage } from "./pages/information-page/information-page";
import { ResetPassword } from "./pages/password/reset/reset";
import { ResetPasswordConfirm } from "./pages/password/reset_confirm/reset_confirm";

import { Footer } from "./components/shared-components/footer/footer";
import { SiteHeader } from "./components/shared-components/site-header/site-header";
import { ConfigContext } from "./contexts/config-context";
import { NewListing } from "./pages/new-listing/new-listing";
import { SearchPage } from "./pages/search-page/search-page";
import { ListingDetail } from "./pages/listing-detail/listing-detail";
import { NewListingSuccess } from "./pages/new-listing-success/new-listing-success";

import { UserPanel } from "./pages/user-panel/user-panel";
import { UserSecurity } from "./pages/user-panel/components/user-security/user-security";
import { PanelListings } from "./pages/user-panel/components/panel-listings/panel-listings";
import { ContactSupport } from "./pages/user-panel/components/contact-support/contact-support";
import { ListingNotFound } from "./pages/listing-not-found/listing-not-found";
import { TransactionPage } from "./pages/transaction-page/transaction-page";
import { UserInbox } from "./pages/user-panel/components/user-inbox/user-inbox";
import { UserNotificationList } from "./pages/user-panel/components/user-notification-list/user-notification-list";
import { UserData } from "./pages/user-panel/components/user-data/user-data";
import { NewListingData } from "./pages/new-listing-data/new-listing-data";
import { gapi } from "gapi-script";
import {ErrorBoundary} from "./components/error-boundary/error-boundary";
import { Statistics } from "./pages/statistics/statistics";
import { UserContext } from "./contexts/userContext";
import  ResponsiveNavigation  from "./components/responsive-navigation/responsive-navigation";
import { MobileTabBar } from "./components/mobile-tab-bar/mobile-tab-bar";
import { CountsProvider } from "./contexts/counts-context";
import { InterfaceContext } from "./contexts/interface-context";
import { AdvertismentOfferPage } from "./pages/advertisment-offer/advertisment-offer-page";
import { TaxRefundGuide } from "./pages/guide/tax-refund-guide";
import { AdvertisingGuide } from "./pages/guide/advertising-guide";
import { TermsPage } from "./pages/terms/terms-page";
const img1 = require("./assets/images/home.jpg");
const img2 = require("./assets/images/saveti.jpg");
const img3 = require("./assets/images/dokumentacija.jpg");
const img4 = require("./assets/images/kredit.jpg");


export const App = () => {
  const { listingTypeCode } = useContext(ConfigContext);
  const location = useLocation();
  const navigationType = useNavigationType();

  // following a link opens the page from the top; back/forward and in-place
  // updates (search filters) keep their scroll position
  useEffect(() => {
    if (navigationType === "PUSH") window.scrollTo(0, 0);
  }, [location.key, navigationType]);
  const isPanel = location.pathname.startsWith("/korisnik");
  // guests are sent to the login page, which brings them back here afterwards
  const loginRedirect = <Navigate to="/login" replace state={{ from: location.pathname }} />;

  gapi.load("client:auth2", () => {
    gapi.client.init({
      clientId:
        "196596446612-6e8g7gcde4n26v5n3ekjphi9qev9vnpk.apps.googleusercontent.com",
      plugin_name: "chat",
    });
  });

  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  // console.log(userPaths);

  // const [user, setUser] = useContext(UserContext);

  // const value = useMemo(() => ({ user, setUser }), [user, setUser]);
  const {responsiveMenuVisible,responsiveMenuOpen} = useContext(InterfaceContext);

  
  
  useEffect(() => {
    userEventEmitter.on('logout', () => {
        setUser(null);
    });

    // Cleanup to avoid memory leaks
    return () => {
        userEventEmitter.removeAllListeners('logout');
    };
}, [setUser]);


  return (
    <div className="App">
     
      <Suspense fallback={null}>
      <UserContext.Provider value={{ user, setUser }}>
      <CountsProvider>
      <ErrorBoundary>
      <SiteHeader />
      {/* its own boundary: while the menu's translations load, only the menu waits, not the whole page (hiding the page breaks the map) */}
      {responsiveMenuVisible && responsiveMenuOpen && <Suspense fallback={null}><ResponsiveNavigation/></Suspense>}
      <div className={`app-content-wrap home ${isPanel ? "panel" : ""}`}>
        <div className="content-wrap">
          
            <Routes>
              <Route exact path="/" element={<MainPage />} />
              <Route path="/login" index element={<Login />} />
              <Route path="/register" index element={<Register />} />
              <Route path="/confirm_mail/:key" index element={<ConfirmMail />} />
              <Route path="/password/reset" index element={<ResetPassword />} />
              <Route path="/password/reset/confirm/:uid/:token" index element={<ResetPasswordConfirm />} />
              <Route path="/postavi-oglas" element={<NewListing />}>
                
                <Route path="/postavi-oglas/prodaja" element={ user? <NewListingData type={listingTypeCode.sale} /> : loginRedirect} />
                <Route path="/postavi-oglas/izdavanje" element={ user? <NewListingData type={listingTypeCode.rent}/> : loginRedirect} />
                <Route path="/postavi-oglas/stan-na-dan" element={ user? <NewListingData type={listingTypeCode.short_term} /> : loginRedirect} />
                <Route path="/postavi-oglas/azuriranje/:id" element={ user? <NewListingData /> : loginRedirect } />
              </Route>

              <Route path="/korisnik" element={user? <UserPanel /> : loginRedirect}>
                <Route index element={<UserData />} />
                <Route path="/korisnik/podaci" element={<UserData />} />
                <Route path="/korisnik/sigurnost" element={<UserSecurity />} />
                <Route path="/korisnik/oglasi" element={<PanelListings source="active" key="active" />} />
                <Route path="/korisnik/praceni" element={<PanelListings source="favorite" key="favorite" />} />
                <Route path="/korisnik/neaktivni-oglasi" element={<PanelListings source="inactive" key="inactive" />} />
                <Route path="/korisnik/poruke" element={<UserInbox />} />
                <Route path="/korisnik/obavestenja" element={<UserNotificationList />} />
                <Route path="/korisnik/kontakt" element={<ContactSupport />} />
                <Route path="/korisnik/kredit" element={<TransactionPage />} />
                <Route path="/korisnik/oglasavanje" element={<AdvertismentOfferPage />} />
                <Route path="/korisnik/statistika/:id" element={<Statistics />} />
                <Route path="*" element={<UserData />} />
              </Route>
              <Route path="/prodaja" element={<SearchPage title="sale" key="sale" />} />
              <Route path="/izdavanje" element={<SearchPage title="rent" key="rent" />} />
              <Route path="/stan-na-dan" element={<SearchPage title="short_term" key="short_term" />} />
              <Route path="/postavljen-novi" element={user? <NewListingSuccess /> : <MainPage />} />
              <Route path="/nepostojeci-oglas" element={<ListingNotFound />} />

              <Route path="/oglas/:id" element={<ListingDetail />} />
              <Route path="/vodic/povracaj-poreza" element={<TaxRefundGuide />} />
              <Route path="/vodic/oglasavanje" element={<AdvertisingGuide />} />

              <Route
                path="/uputstvo-prodavci"
                element={
                  <InformationPage
                    title="Informacije za prodavce"
                    backgroundImage={img2}
                  />
                }
              />
              <Route
                path="/uputstvo-zakupci"
                element={
                  <InformationPage
                    title="Informacije za zakupce"
                    backgroundImage={img3}
                  />
                }
              />
              <Route
                path="/privacy"
                element={
                  <InformationPage
                    title="Informacije za zakupce"
                    backgroundImage={img3}
                  />
                }
              />
              <Route path="/terms" element={<TermsPage />} />
              {/* earlier addresses of the advertising guide */}
              <Route path="/uputstvo-oglasavanje" element={<Navigate to="/vodic/oglasavanje" replace />} />
              <Route path="/upustvo-oglasavanje" element={<Navigate to="/vodic/oglasavanje" replace />} />
              <Route
                path="/uputstvo"
                element={
                  <InformationPage title="Uputstvo" backgroundImage={img1} />
                }
              />
              {/* <Route exact path="/prodaja" element={<MaiprodnPage />}/>
                      <Route exact path="/izdavanje" element={<MainPage />}/>
          <Route exact path="/stan-na-dan" element={<MainPage />}/>*/}
              <Route
                path="/trazis-nekretninu"
                element={
                  <InformationPage
                    title="Tražiš nekretninu"
                    backgroundImage={img4}
                  />
                }
              />
               <Route
                path="/saveti"
                element={
                  <InformationPage
                    title="Saveti"
                    backgroundImage={img4}
                  />
                }
              />
               <Route
                path="/dokumentacija"
                element={
                  <InformationPage
                    title="Dokumentacija"
                    backgroundImage={img4}
                  />
                }
              />
               <Route
                path="/kredit"
                element={
                  <InformationPage
                    title="Kupovina na kredit"
                    backgroundImage={img4}
                  />
                }
              />
              {/* 404 */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
         
        </div>
      </div>
      <Footer />
      <MobileTabBar />
      </ErrorBoundary>
      </CountsProvider>
      </UserContext.Provider>
      </Suspense>
     
    </div>
  );
};

export default App;
